import FieldController from './FieldController';
import Const from '../util/Constants';
import Util from '../util/Util';

class ActionController {
  
  static checkAction = (action, prevAction, actions, model) => {
    for(let i = 0; actions && i < actions.length; i++) {
      const conditions = actions[i].conditions;
      let result = false;
      for(let j = 0; j < conditions.length; j++) {
        const tmpResult = ActionController.applyCondition(conditions[j], model);
        if(actions[i].condition_option === Const.OR && tmpResult) {
          result = true;
          break;
        } else if(actions[i].condition_option === Const.AND && !tmpResult) {
          result = false;
          break;
        }
      }
      if(result) {
        const binary = Util.decimalToBinary(actions[i].action);
        return parseInt(binary[action]) === Const.True;
      }
    }
    return prevAction;
  }

  static applyCondition = (filter, model) => {
    let field = filter.field;
    if(!field) return true;
    const condition = filter.condition;
    let value = Const.replaceAll(filter.value, Const.Qot, Const.DoublQot);
    let type = filter.type;
    let fValue = model[field];
    if(field.includes(Const.Address) && field.includes(Const.Opt)) {
      const tmpField = field.split(Const.Opt);
      field = tmpField[0];
      let tmp = '';
      if(tmpField[1] === Const.Street) { type = Const.MultiValue; tmp = Const.Street; }
      else if(tmpField[1] === Const.City) { type = Const.MultiSelect; tmp = Const.City; }
      else if(tmpField[1] === Const.State) { type = Const.MultiSelect; tmp = Const.State; }
      else if(tmpField[1] === Const.Country) {type = Const.MultiSelect; tmp = Const.Country;}
      else if(tmpField[1] === Const.Pin) { type = Const.MultiValue; tmp = Const.Pin; }
      else if(model.address === undefined || model.address === null) return true;
      else { console.log("Please check field"); return true; }
      fValue = Const.Opt + model.address[0][tmp] + Const.Opt;
    } else if(type.includes(Const.Opt)) {
      type = type.split(Const.Opt)[0];
    }

    if(fValue === undefined) {
      fValue = '';
    }
    if(type === Const.Text || type === Const.TextArea || type === Const.Website
      || type === Const.MultiValue || type === Const.Phone || type === Const.Email) {
      return ActionController.applyConditionText(condition, value, fValue);
    } else if(type === Const.Date || type === Const.DateTime) {
      return ActionController.applyConditionDate(condition, value, fValue);
    } else if(type === Const.Select) {
      fValue = fValue ? Const.Opt + fValue + Const.Opt : `${Const.Opt}0${Const.Opt}`;
      return ActionController.applyConditionMulti(condition, value, fValue);
    } else if(type === Const.MultiSelect) {
      return ActionController.applyConditionMulti(condition, value, fValue);
    } else if(type === Const.Toggle || type === Const.Complete) {
      return ActionController.applyConditionComplete(condition, fValue);
    } else { 
      console.log(`Please check type : ${type}`); 
      return true; 
    }
  }

  static applyConditionText = (condition, value, fValue) => {
    if(condition === FieldController.Equals) return fValue === value;
    else if(condition === FieldController.NotEquals) return fValue !== value;
    else if(condition === FieldController.In) return fValue.includes(value);
    else if(condition === FieldController.NotIn) return !fValue.includes(value);
    else if(condition === FieldController.Empty) return fValue.length === 0;
    else if(condition === FieldController.NotEmpty) return fValue.length !== 0;
    else if(condition === FieldController.StartWith) return fValue.indexOf(value) === 0;
    else if(condition === FieldController.EndsWith)
      return fValue.lastIndexOf(value) === fValue.length - value.length - 1;
    else return true;
  }

  static applyConditionDate = (condition, value, fValue) => {
    const values = value.split(Const.Opt);
    values[0] = Util.serverStringDateTimeToDate(values[0]);
    values[1] = Util.serverStringDateTimeToDate(values[1]);
    const val = Util.serverStringDateTimeToDate(fValue);
    if(condition === FieldController.In) return values[0] <= val && val <= values[1];
    else if(condition === FieldController.NotIn) return val <= values[0] && values[1] <= val;
    else if(condition === FieldController.Empty) return val === null;
    else if(condition === FieldController.NotEmpty) return val !== null;
    else if(condition === FieldController.StartWith) return values[0] <= val;
    else if(condition === FieldController.EndsWith) return val <= values[1];
    else if(condition === FieldController.GreaterThan) return values[0] <= val;
    else if(condition === FieldController.SmallerThan) return val <= values[1];
    else return true;
  }

  static applyConditionMulti = (condition, value, fValue) => {
    if(condition === FieldController.Empty) return !fValue || fValue === '' || fValue === '~0~';
    else if(condition === FieldController.NotEmpty) return fValue && fValue !== '' && fValue !== '~0~';

    let values = value && value !== '' ? value.substring(1, value.length - 1).split(Const.Opt) : [];
    let values1 = fValue && fValue !== '' ? fValue.substring(1, fValue.length - 1).split(Const.Opt)
      : [];
    let count = 0;
    for(let i = 0; i < values.length; i++) {
      for(let j = 0; j < values1.length; j++) {
        if(values[i] === values1[j]) { 
          count++; 
          break; 
        }  
      }
    }
    
    if(condition === FieldController.Equals) return count === values.length;
    else if(condition === FieldController.NotEquals) return count === 0;
    else if(condition === FieldController.In) return count > 0;
    else if(condition === FieldController.NotIn) return count === 0;
    else return true;
  }

  static applyConditionComplete = (condition, fValue) => {
    if(condition === FieldController.In) return fValue === Const.False;
    else if(condition === FieldController.NotIn) return fValue === Const.True;
    return true;
  }
}
export default ActionController;